// extracted by mini-css-extract-plugin
module.exports = {"text":"TextMuted_text__1XNDg"};